import { setInfluenceAnalysisValueFilter as setInfluenceAnalysisValueFilterDiagram , updateDiagramInfluenceAnalysis} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    valueFilter?: string,
}

export const applyInfluenceAnalysisValueFilter = ({
    valueFilter,
    eventEmitter,
}: Props) => {
    setInfluenceAnalysisValueFilterDiagram(valueFilter);
    apiProvider.updateDiagramInfluencers();
    eventEmitter.emit(Event.applyFilter);
};
